import { render, staticRenderFns } from "./PurchasePaymentModeAccountCreateView.vue?vue&type=template&id=0b820caa"
import script from "./PurchasePaymentModeAccountCreateView.vue?vue&type=script&lang=js"
export * from "./PurchasePaymentModeAccountCreateView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports